import React, { useState } from 'react';
import { Shield, XIcon } from 'lucide-react';
function LegalModal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-47">
      <div className="bg-navy-900 border border-navy-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-48">
        <div className="flex items-center justify-between p-6 border-b border-navy-700 sticky top-0 bg-navy-900 rounded-t-2xl" data-id="element-49">
          <h2 className="text-xl font-bold text-white" data-id="element-50">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-navy-800" aria-label="Cerrar" data-id="element-51">
            <XIcon className="w-5 h-5" data-id="element-52" />
          </button>
        </div>
        <div className="p-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-53">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-navy-950 py-12 px-4 border-t border-navy-800" data-id="element-54">
        <div className="max-w-4xl mx-auto text-center" data-id="element-55">
          <div className="flex justify-center mb-6" data-id="element-56">
            <Shield className="w-8 h-8 text-gold-500/50" data-id="element-57" />
          </div>
          <p className="text-gray-500 text-sm mb-4" data-id="element-58">
            © {new Date().getFullYear()} Protocolo 11:11. Todos los derechos
            reservados.
          </p>
          <div className="flex justify-center gap-6 mb-4" data-id="element-59">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-gold-500 text-sm transition-colors underline underline-offset-2" data-id="element-60">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-gold-500 text-sm transition-colors underline underline-offset-2" data-id="element-61">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-62">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {activeModal === 'privacy' && <LegalModal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-63">
          <p data-id="element-64">
            <strong data-id="element-65">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-66">
            En Protocolo 11:11, nos comprometemos a proteger tu privacidad. Esta
            política describe cómo recopilamos, usamos y protegemos tu
            información personal.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-67">
            1. Información que recopilamos
          </h3>
          <p data-id="element-68">
            Recopilamos información que nos proporcionas directamente, como tu
            nombre, correo electrónico y cualquier dato que ingreses en nuestros
            formularios. También podemos recopilar información de uso del sitio
            de forma automática mediante cookies y tecnologías similares.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-69">
            2. Uso de la información
          </h3>
          <p data-id="element-70">
            Utilizamos tu información para proporcionarte nuestros servicios,
            comunicarnos contigo, mejorar nuestra plataforma y enviarte
            contenido relevante. No vendemos ni compartimos tu información
            personal con terceros sin tu consentimiento.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-71">
            3. Protección de datos
          </h3>
          <p data-id="element-72">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información contra acceso no autorizado, alteración o
            destrucción.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-73">
            4. Tus derechos
          </h3>
          <p data-id="element-74">
            Tienes derecho a acceder, rectificar o eliminar tu información
            personal en cualquier momento. Para ejercer estos derechos, puedes
            comunicarte con nosotros a través de los canales disponibles en
            nuestra plataforma.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-75">
            5. Cookies
          </h3>
          <p data-id="element-76">
            Utilizamos cookies para mejorar tu experiencia de navegación y
            analizar el tráfico del sitio. Puedes configurar tu navegador para
            rechazar cookies, aunque esto puede afectar la funcionalidad del
            sitio.
          </p>
        </LegalModal>}

      {activeModal === 'terms' && <LegalModal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-77">
          <p data-id="element-78">
            <strong data-id="element-79">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-80">
            Al acceder y utilizar este sitio web, aceptas cumplir con los
            siguientes términos y condiciones. Si no estás de acuerdo, te
            pedimos que no utilices nuestros servicios.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-81">
            1. Uso del servicio
          </h3>
          <p data-id="element-82">
            Nuestros servicios están destinados exclusivamente para uso personal
            y no comercial. Te comprometes a no utilizar el contenido de este
            sitio para fines ilegales o no autorizados.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-83">
            2. Propiedad intelectual
          </h3>
          <p data-id="element-84">
            Todo el contenido de este sitio, incluyendo textos, gráficos,
            logotipos, imágenes y software, es propiedad de Protocolo 11:11 y
            está protegido por las leyes de propiedad intelectual aplicables.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-85">
            3. Limitación de responsabilidad
          </h3>
          <p data-id="element-86">
            Los resultados pueden variar según cada persona. No garantizamos
            resultados específicos. El contenido proporcionado es de carácter
            informativo y educativo, y no constituye asesoramiento profesional.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-87">
            4. Pagos y reembolsos
          </h3>
          <p data-id="element-88">
            Todos los pagos son procesados de forma segura. Las políticas de
            reembolso se especifican en el momento de la compra y están sujetas
            a los términos indicados en la oferta correspondiente.
          </p>
          <h3 className="text-white font-semibold text-base pt-2" data-id="element-89">
            5. Modificaciones
          </h3>
          <p data-id="element-90">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor desde su publicación
            en este sitio. El uso continuado del servicio implica la aceptación
            de los términos actualizados.
          </p>
        </LegalModal>}
    </>;
}